import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@/lib/utils';
import { Button } from './';

const betherePrimaryBtnClass =
  'inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-[var(--bethere-radius-md)] bg-[var(--bethere-accent)] px-5 font-bold text-[#121212] shadow-sm transition hover:bg-[var(--bethere-secondary)] hover:shadow-md';

export const FestivalHeader = ({
  title,
  onSave,
  showSave,
  showAdd,
  addAction,
  addTitle,
  showExit,
  subtitle,
  variant = 'default',
  editHref,
  ...props
}) => {
  const isBethere = variant === 'bethere';

  return (
    <div
      className={cn(
        isBethere
          ? 'section-header-bethere mb-6 flex max-w-full flex-col gap-4 sm:flex-row sm:items-start sm:justify-between'
          : 'mb-4 flex items-center justify-between border-b-[5px] border-[var(--muted)]',
      )}
      {...props}
    >
      <div className="min-w-0">
        <h1
          className={cn(
            isBethere
              ? 'mb-0 text-[length:var(--bethere-f-h1)] font-bold leading-[1.2] text-[#121212]'
              : 'font-normal text-[#73797f] [&_svg]:mr-4 [&_svg]:text-[var(--primary)]',
          )}
        >
          {!isBethere && <FontAwesomeIcon icon={['fas', 'calendar-days']} />}{' '}
          {title}
        </h1>
        {subtitle && isBethere && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[var(--muted-foreground)]">
            {subtitle}
          </p>
        )}
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-3">
        {editHref && (
          <Link className="inline-block" to={editHref}>
            <Button>
              <FontAwesomeIcon icon={['fas', 'pen-to-square']} />
              Edit
            </Button>
          </Link>
        )}
        {showExit && (
          <Link className="mr-4 inline-block" to="/">
            <Button>
              <FontAwesomeIcon icon={['fas', 'reply']} />
              Dashboard
            </Button>
          </Link>
        )}
        {showSave && (
          <Button onClick={onSave}>
            <FontAwesomeIcon icon={['far', 'save']} />
            Save
          </Button>
        )}
        {showAdd && isBethere && (
          <button
            type="button"
            onClick={addAction}
            className={betherePrimaryBtnClass}
          >
            <FontAwesomeIcon icon={['fas', 'plus']} className="opacity-90" />
            {addTitle}
          </button>
        )}
        {showAdd && !isBethere && (
          <Button onClick={addAction}>
            <FontAwesomeIcon icon={['far', 'plus']} />
            {addTitle}
          </Button>
        )}
      </div>
    </div>
  );
};
